import i18next from 'i18next';
import { initReactI18next } from "react-i18next";
import en from './locales/en.json';

i18next
	.use(initReactI18next)
	.init({
		interpolation: {
			escapeValue: false,
		},
		lng: 'en',
		// fallbackLng: 'en',
		resources: {
			// nl: { translation: nl },
			// fr: { translation: fr },
			en: { translation: en },
		},
		react: {
			wait: true,
		}
	});

//*** call without param to use language detector
// i18next.changeLanguage();

export default i18next